import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SponsorTiers } from "@/components/sponsor/SponsorTiers";
import { SponsorForm } from "@/components/sponsor/SponsorForm";
import { SponsorBankDetails } from "@/components/sponsor/SponsorBankDetails";
import { DonationOptions } from "@/components/support/DonationOptions";
import { DonationForm } from "@/components/support/DonationForm";
import { Building2, Heart } from "lucide-react";

export const SupportTabs = () => {
  return (
    <section id="support-tabs" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Choose Your Way to Support
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Whether you're a business looking for partnership opportunities or an individual 
            who wants to make a difference, we have options that work for you.
          </p>
        </div>

        <Tabs defaultValue="corporate" className="w-full max-w-6xl mx-auto">
          <TabsList className="grid w-full grid-cols-2 mb-12 h-16">
            <TabsTrigger 
              value="corporate" 
              className="flex items-center gap-2 text-lg py-4"
            >
              <Building2 className="h-5 w-5" />
              Corporate Partnership
            </TabsTrigger>
            <TabsTrigger 
              value="individual" 
              className="flex items-center gap-2 text-lg py-4"
            >
              <Heart className="h-5 w-5" />
              Individual Giving
            </TabsTrigger>
          </TabsList>

          <TabsContent value="corporate" className="space-y-20">
            <div className="text-center mb-12">
              <h3 className="text-3xl font-bold mb-4">Corporate Sponsorship Opportunities</h3>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                Partner with us to reach families while supporting educational content that makes a difference. 
                Our sponsorship packages offer meaningful brand exposure and community impact.
              </p>
            </div>
            
            <SponsorTiers />
            <SponsorBankDetails />
            <SponsorForm />
          </TabsContent>

          <TabsContent value="individual" className="space-y-20">
            <div className="text-center mb-12">
              <h3 className="text-3xl font-bold mb-4">Individual Donations</h3>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                Every donation, no matter the size, helps us create more content and reach more children. 
                Join our community of supporters making a difference in children's education.
              </p>
            </div>
            
            <DonationOptions />
            <DonationForm />
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
};